import { combineReducers } from 'redux'
import notification from './notification'
import modalReducer from '@/state/reducers/modal'
import pageflip from '@/state/reducers/pageflip'

const uiReducer = combineReducers({
  pageflip,
  notification,
  modal: modalReducer,
})

export default uiReducer



// WEBPACK FOOTER //
// ./state/reducers/ui.js